import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterW = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { xmlns: "http://www.w3.org/2000/svg", d: "M8.61623 16L6.24023 7.59998H7.69223L9.45623 14.164L11.3642 7.59998H12.6362L14.5322 14.164L16.2962 7.59998H17.7482L15.3722 16H13.7762L12.0002 9.86798L10.2122 16H8.61623Z" }),
});

export { IconCapitalLetterW };
